import React, { useEffect, useRef, useState } from "react";
import './LifeAtHitech.css'

const LifeAtHitech = () => {

  const [activeVideo, setActiveVideo] = useState(null)
  const videoRefs = useRef({})

  const videosData = [
    {
      id: 1,
      src: "/life-at-hitech-video/EVENTS-20.06.2022.mp4",
      title: "Events at Hi-Tech - 20.06.2022",
    }, 
    {
      id: 2,
      src: "/life-at-hitech-video/Continual Learning at Hitech.mp4",
      title: "Continual Learning at Hi-Tech",
    },
    {
      id: 3,
      src: "/life-at-hitech-video/RealEstate Marking Presentaion_Navinbhai.mp4",
      title: "Real-Estate Marking",
    },
    {
      id: 4,
      src: "https://prepseed.s3.ap-south-1.amazonaws.com/hitech/Hi+Tech+Get+To+Gether+2025+Highlight.mp4",
      title: "Diwali Celebration 2025 at Ahmedabad",
    },
    {
      id: 5,
      src: "https://prepseed.s3.ap-south-1.amazonaws.com/hitech/Hitech+Reel+Without+Logo.mp4",
      title: "Diwali Celebration 2025 at Surat"
    },

  ]
  return (
    <>
      <img
        src="/Sources/images/banner/life-at-hitech-bg.jpeg"
        alt="404 -Not Given"
        className="about_img"
        // style={{ marginLeft: window.innerWidth > 1355 ? "5%" : "" }}
      />
      <section className="lifeAtHitech mobile_margin">
        <div className="section_padding"></div>
        <div className="container">
          <div>
            <div>
              <p
                className="is-size-2 has-text-weight-semibold has-text-centered mb-2"
                style={{ color: "#0d2e61", fontSize: "40px" }}
              >
                Life at Hi-Tech
              </p>
            </div>

            <div className="life-para">
              <p className="life-intro">
              At Hi-Tech, we cultivate a work environment built on discipline, accountability, and mutual respect. We encourage our teams to take ownership, strengthen their capabilities, and consistently raise the standard of execution across projects.
            </p>

            <p className="life-intro-2">
              Our culture supports structured thinking and practical problem-solving. Whether on site or in the office, collaboration and responsibility guide how we approach challenges and deliver results.
            </p>
            </div>

            <div className="video-grid">
              { videosData.map((video) => (
                <div key={video.id}>
                  <div className="video-wrapper" onClick={(e) => {
                    const currentVideo = videoRefs.current[video.id]

                    if (!currentVideo) return

                    if (activeVideo === video.id) {
                      currentVideo.pause()
                      setActiveVideo(null)
                    } else {
                      Object.values(videoRefs.current).forEach((vid) => {
                        if (vid && vid !== currentVideo) vid.pause()
                      })

                      setActiveVideo(video.id)

                      setTimeout(() => {
                        currentVideo.play().catch((err) => {
                          console.log("play prevented: ", err)
                        })
                      }, 0)
                    }
                  }}>
                    <video ref={(el) => (videoRefs.current[video.id] = el )} src={video.src} controls={activeVideo === video.id} preload="metadata" className="video-player" />

                      { activeVideo !== video.id && (
                    <div className="video-overlay">
                      <div className="play-icon">
                      </div>
                    </div>
                  )}
                  </div>


                  <div className="video-content">
                    <h4 className="video-title">
                      {video.title}
                    </h4>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default LifeAtHitech;
